import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppMaterialModule } from 'src/app/app.material.module';
import { ConfirmAlertComponent } from './confirm-alert/confirm-alert.component';
import { DefaultAlertComponent } from './default-alert/default-alert.component';

@NgModule({
  declarations: [ConfirmAlertComponent, DefaultAlertComponent],
  imports: [CommonModule, AppMaterialModule],
})
export class AlertModule {}
